// iOS Safari only applies :active during touch when a touchstart listener
// exists; without this, press states (heart/tip stickers, nav buttons) never
// show on iPhones.
document.addEventListener('touchstart', function () {}, { passive: true })

/* Move the page without the rest of the site mistaking it for a swipe.
 *
 * Two things watch window.scrollY and cannot tell code from a finger: the
 * header hide/show handler (down hides, up reveals) and the URL-bar tracker
 * that publishes --url-bar-overlay. During any programmatic scroll the visual
 * viewport lags the layout scroll, so visualViewport.offsetTop reads non-zero
 * with no browser chrome actually overlaying — and that value is the sticky
 * chain's `top`, which is how a strip of page background appears above the
 * announcement bar. Both stand down while window.__coScrollLock is raised.
 *
 * A COUNTER, not a boolean, so overlapping scrolls cannot release it early.
 *
 * Pass a function that does the scrolling — scrollTo, scrollBy, or
 * scrollIntoView all work, since the flag is what matters, not the method.
 * Set opts.instant when the scroll does not animate, so the backstop timer
 * can be short; a lock held longer than the scroll keeps the URL-bar tracker
 * standing down, which is the same staleness this is here to prevent.
 *
 * The same shape is inlined in info-tabs.liquid, which predates this helper
 * and is device-verified — leave it be; converting it is its own change with
 * its own device pass. (header.liquid's inline copy left with the open-glide.)
 */
window.coScrollSafely = function (perform, opts) {
	opts = opts || {}
	window.__coScrollLock = (window.__coScrollLock || 0) + 1

	let released = false
	const release = () => {
		if (released) return
		released = true
		window.removeEventListener('scrollend', release)
		window.__coScrollLock = Math.max(0, (window.__coScrollLock || 1) - 1)
	}

	perform()

	/* Release when the scroll actually finishes where that is reported, with a
	   timeout as the backstop — a smooth scroll's duration is the browser's to
	   choose, and scrollend only shipped in Safari 18. Whichever fires first. */
	if ('onscrollend' in window) window.addEventListener('scrollend', release)
	setTimeout(release, opts.instant ? 60 : 900)
}

function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
		)
	)
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute('role', 'button')
	summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'))

	if (summary.nextElementSibling.getAttribute('id')) {
		summary.setAttribute('aria-controls', summary.nextElementSibling.id)
	}

	summary.addEventListener('click', (event) => {
		event.currentTarget.setAttribute(
			'aria-expanded',
			!event.currentTarget.closest('details').hasAttribute('open')
		)
	})

	summary.parentElement.addEventListener('keyup', onKeyUpEscape)
})

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container)
	var first = elements[0]
	var last = elements[elements.length - 1]

	removeTrapFocus()

	trapFocusHandlers.focusin = (event) => {
		if (
			event.target !== container &&
			event.target !== last &&
			event.target !== first
		)
			return

		document.addEventListener('keydown', trapFocusHandlers.keydown)
	}

	trapFocusHandlers.focusout = function () {
		document.removeEventListener('keydown', trapFocusHandlers.keydown)
	}

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault()
			first.focus()
		}

		//  On the first focusable element and tab backward, focus the last element.
		if (
			(event.target === container || event.target === first) &&
			event.shiftKey
		) {
			event.preventDefault()
			last.focus()
		}
	}

	document.addEventListener('focusout', trapFocusHandlers.focusout)
	document.addEventListener('focusin', trapFocusHandlers.focusin)

	elementToFocus.focus()
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
	document.querySelector(':focus-visible')
} catch (e) {
	focusVisiblePolyfill()
}

function focusVisiblePolyfill() {
	const navKeys = [
		'ARROWUP',
		'ARROWDOWN',
		'ARROWLEFT',
		'ARROWRIGHT',
		'TAB',
		'ENTER',
		'SPACE',
		'ESCAPE',
		'HOME',
		'END',
		'PAGEUP',
		'PAGEDOWN',
	]
	let currentFocusedElement = null
	let mouseClick = null

	window.addEventListener('keydown', (event) => {
		if (navKeys.includes(event.code.toUpperCase())) {
			mouseClick = false
		}
	})

	window.addEventListener('mousedown', (event) => {
		mouseClick = true
	})

	window.addEventListener(
		'focus',
		() => {
			if (currentFocusedElement)
				currentFocusedElement.classList.remove('focused')

			if (mouseClick) return

			currentFocusedElement = document.activeElement
			currentFocusedElement.classList.add('focused')
		},
		true
	)
}

function pauseAllMedia() {
	document.querySelectorAll('.js-youtube').forEach((video) => {
		video.contentWindow.postMessage(
			'{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
			'*'
		)
	})
	document.querySelectorAll('.js-vimeo').forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', '*')
	})
	document.querySelectorAll('video').forEach((video) => video.pause())
	document.querySelectorAll('product-model').forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause()
	})
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener('focusin', trapFocusHandlers.focusin)
	document.removeEventListener('focusout', trapFocusHandlers.focusout)
	document.removeEventListener('keydown', trapFocusHandlers.keydown)

	if (elementToFocus) elementToFocus.focus()
}

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== 'ESCAPE') return

	const openDetailsElement = event.target.closest('details[open]')
	if (!openDetailsElement) return

	const summaryElement = openDetailsElement.querySelector('summary')
	openDetailsElement.removeAttribute('open')
	summaryElement.setAttribute('aria-expanded', false)
	summaryElement.focus()
}

class QuantityInput extends HTMLElement {
	constructor() {
		super()
		this.input = this.querySelector('input')
		this.changeEvent = new Event('change', { bubbles: true })

		this.querySelectorAll('button').forEach((button) =>
			button.addEventListener('click', this.onButtonClick.bind(this))
		)
	}

	onButtonClick(event) {
		event.preventDefault()
		const previousValue = this.input.value

		event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
		if (previousValue !== this.input.value)
			this.input.dispatchEvent(this.changeEvent)
	}
}

customElements.define('quantity-input', QuantityInput)

function debounce(fn, wait) {
	let t
	return (...args) => {
		clearTimeout(t)
		t = setTimeout(() => fn.apply(this, args), wait)
	}
}

function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: `application/${type}`,
		},
	}
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
	window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments)
	}
}

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i]
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i
			return i
		}
	}
}

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent('on' + eventName, callback)
}

Shopify.postLink = function (path, options) {
	options = options || {}
	var method = options['method'] || 'post'
	var params = options['parameters'] || {}

	var form = document.createElement('form')
	form.setAttribute('method', method)
	form.setAttribute('action', path)

	for (var key in params) {
		var hiddenField = document.createElement('input')
		hiddenField.setAttribute('type', 'hidden')
		hiddenField.setAttribute('name', key)
		hiddenField.setAttribute('value', params[key])
		form.appendChild(hiddenField)
	}
	document.body.appendChild(form)
	form.submit()
	document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (
	country_domid,
	province_domid,
	options
) {
	this.countryEl = document.getElementById(country_domid)
	this.provinceEl = document.getElementById(province_domid)
	this.provinceContainer = document.getElementById(
		options['hideElement'] || province_domid
	)

	Shopify.addListener(
		this.countryEl,
		'change',
		Shopify.bind(this.countryHandler, this)
	)

	this.initCountry()
	this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute('data-default')
		Shopify.setSelectorByValue(this.countryEl, value)
		this.countryHandler()
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute('data-default')
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value)
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex]
		var raw = opt.getAttribute('data-provinces')
		var provinces = JSON.parse(raw)

		this.clearOptions(this.provinceEl)
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = 'none'
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement('option')
				opt.value = provinces[i][0]
				opt.innerHTML = provinces[i][1]
				this.provinceEl.appendChild(opt)
			}

			this.provinceContainer.style.display = ''
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild)
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement('option')
			opt.value = values[i]
			opt.innerHTML = values[i]
			selector.appendChild(opt)
		}
	},
}

class ModalDialog extends HTMLElement {
	constructor() {
		super()
		this.querySelector('[id^="ModalClose-"]').addEventListener(
			'click',
			this.hide.bind(this, false)
		)
		this.addEventListener('keyup', (event) => {
			if (event.code.toUpperCase() === 'ESCAPE') this.hide()
		})
		if (this.classList.contains('media-modal')) {
			this.addEventListener('pointerup', (event) => {
				if (
					event.pointerType === 'mouse' &&
					!event.target.closest('deferred-media, product-model')
				)
					this.hide()
			})
		} else {
			this.addEventListener('click', (event) => {
				if (event.target === this) this.hide()
			})
		}
	}

	connectedCallback() {
		if (this.moved) return
		this.moved = true
		document.body.appendChild(this)
	}

	show(opener) {
		this.openedBy = opener
		const popup = this.querySelector('.template-popup')
		document.body.classList.add('overflow-hidden')
		this.setAttribute('open', '')
		if (popup) popup.loadContent()
		trapFocus(this, this.querySelector('[role="dialog"]'))
		window.pauseAllMedia()
	}

	hide() {
		document.body.classList.remove('overflow-hidden')
		document.body.dispatchEvent(new CustomEvent('modalClosed'))
		this.removeAttribute('open')
		removeTrapFocus(this.openedBy)
		window.pauseAllMedia()
	}
}
customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
	constructor() {
		super()

		const button = this.querySelector('button')

		if (!button) return
		button.addEventListener('click', () => {
			const modal = document.querySelector(this.getAttribute('data-modal'))
			if (modal) modal.show(button)
		})
	}
}
customElements.define('modal-opener', ModalOpener)

class DeferredMedia extends HTMLElement {
	constructor() {
		super()
		const poster = this.querySelector('[id^="Deferred-Poster-"]')
		if (!poster) return
		poster.addEventListener('click', this.loadContent.bind(this))
	}

	loadContent(focus = true) {
		window.pauseAllMedia()
		if (!this.getAttribute('loaded')) {
			const content = document.createElement('div')
			content.appendChild(
				this.querySelector('template').content.firstElementChild.cloneNode(true)
			)

			this.setAttribute('loaded', true)
			const deferredElement = this.appendChild(
				content.querySelector('video, model-viewer, iframe')
			)
			if (focus) deferredElement.focus()
		}
	}
}

customElements.define('deferred-media', DeferredMedia)

class SliderComponent extends HTMLElement {
	constructor() {
		super()
		this.slider = this.querySelector('[id^="Slider-"]')
		this.sliderItems = this.querySelectorAll('[id^="Slide-"]')
		this.enableSliderLooping = false
		this.currentPageElement = this.querySelector('.slider-counter--current')
		this.pageTotalElement = this.querySelector('.slider-counter--total')
		this.prevButton = this.querySelector('button[name="previous"]')
		this.nextButton = this.querySelector('button[name="next"]')

		if (!this.slider || !this.nextButton) return

		this.initPages()
		const resizeObserver = new ResizeObserver((entries) => this.initPages())
		resizeObserver.observe(this.slider)

		this.slider.addEventListener('scroll', this.update.bind(this))
		this.prevButton.addEventListener('click', this.onButtonClick.bind(this))
		this.nextButton.addEventListener('click', this.onButtonClick.bind(this))
	}

	initPages() {
		this.sliderItemsToShow = Array.from(this.sliderItems).filter(
			(element) => element.clientWidth > 0
		)
		if (this.sliderItemsToShow.length < 2) return
		this.sliderItemOffset =
			this.sliderItemsToShow[1].offsetLeft -
			this.sliderItemsToShow[0].offsetLeft
		this.slidesPerPage = Math.floor(
			(this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
				this.sliderItemOffset
		)
		this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1
		this.update()
	}

	resetPages() {
		this.sliderItems = this.querySelectorAll('[id^="Slide-"]')
		this.initPages()
	}

	update() {
		const previousPage = this.currentPage
		this.currentPage =
			Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1

		if (this.currentPageElement && this.pageTotalElement) {
			this.currentPageElement.textContent = this.currentPage
			this.pageTotalElement.textContent = this.totalPages
		}

		if (this.currentPage != previousPage) {
			this.dispatchEvent(
				new CustomEvent('slideChanged', {
					detail: {
						currentPage: this.currentPage,
						currentElement: this.sliderItemsToShow[this.currentPage - 1],
					},
				})
			)
		}

		if (this.enableSliderLooping) return

		if (
			this.isSlideVisible(this.sliderItemsToShow[0]) &&
			this.slider.scrollLeft === 0
		) {
			this.prevButton.setAttribute('disabled', 'disabled')
		} else {
			this.prevButton.removeAttribute('disabled')
		}

		if (
			this.isSlideVisible(
				this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
			)
		) {
			this.nextButton.setAttribute('disabled', 'disabled')
		} else {
			this.nextButton.removeAttribute('disabled')
		}
	}

	isSlideVisible(element, offset = 0) {
		const lastVisibleSlide =
			this.slider.clientWidth + this.slider.scrollLeft - offset
		return (
			element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
			element.offsetLeft >= this.slider.scrollLeft
		)
	}

	onButtonClick(event) {
		event.preventDefault()
		const step = event.currentTarget.dataset.step || 1
		this.slideScrollPosition =
			event.currentTarget.name === 'next'
				? this.slider.scrollLeft + step * this.sliderItemOffset
				: this.slider.scrollLeft - step * this.sliderItemOffset
		this.slider.scrollTo({
			left: this.slideScrollPosition,
		})
	}
}

customElements.define('slider-component', SliderComponent)

class SlideshowComponent extends SliderComponent {
	constructor() {
		super()
		this.sliderControlWrapper = this.querySelector('.slider-buttons')
		this.enableSliderLooping = true

		if (!this.sliderControlWrapper) return

		this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide')
		if (this.sliderItemsToShow.length > 0) this.currentPage = 1

		this.sliderControlLinksArray = Array.from(
			this.sliderControlWrapper.querySelectorAll('.slider-counter__link')
		)
		this.sliderControlLinksArray.forEach((link) =>
			link.addEventListener('click', this.linkToSlide.bind(this))
		)
		this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this))
		this.setSlideVisibility()

		if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay()
	}

	setAutoPlay() {
		this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay')
		this.autoplaySpeed = this.slider.dataset.speed * 1000

		this.sliderAutoplayButton.addEventListener(
			'click',
			this.autoPlayToggle.bind(this)
		)
		this.addEventListener('mouseover', this.focusInHandling.bind(this))
		this.addEventListener('mouseleave', this.focusOutHandling.bind(this))
		this.addEventListener('focusin', this.focusInHandling.bind(this))
		this.addEventListener('focusout', this.focusOutHandling.bind(this))

		this.play()
		this.autoplayButtonIsSetToPlay = true
	}

	onButtonClick(event) {
		super.onButtonClick(event)
		const isFirstSlide = this.currentPage === 1
		const isLastSlide = this.currentPage === this.sliderItemsToShow.length

		if (!isFirstSlide && !isLastSlide) return

		if (isFirstSlide && event.currentTarget.name === 'previous') {
			this.slideScrollPosition =
				this.slider.scrollLeft +
				this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length
		} else if (isLastSlide && event.currentTarget.name === 'next') {
			this.slideScrollPosition = 0
		}
		this.slider.scrollTo({
			left: this.slideScrollPosition,
		})
	}

	update() {
		super.update()
		this.sliderControlButtons = this.querySelectorAll('.slider-counter__link')
		this.prevButton.removeAttribute('disabled')

		if (!this.sliderControlButtons.length) return

		this.sliderControlButtons.forEach((link) => {
			link.classList.remove('slider-counter__link--active')
			link.removeAttribute('aria-current')
		})
		this.sliderControlButtons[this.currentPage - 1].classList.add(
			'slider-counter__link--active'
		)
		this.sliderControlButtons[this.currentPage - 1].setAttribute(
			'aria-current',
			true
		)
	}

	autoPlayToggle() {
		this.togglePlayButtonState(this.autoplayButtonIsSetToPlay)
		this.autoplayButtonIsSetToPlay ? this.pause() : this.play()
		this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay
	}

	focusOutHandling(event) {
		const focusedOnAutoplayButton =
			event.target === this.sliderAutoplayButton ||
			this.sliderAutoplayButton.contains(event.target)
		if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return
		this.play()
	}

	focusInHandling(event) {
		const focusedOnAutoplayButton =
			event.target === this.sliderAutoplayButton ||
			this.sliderAutoplayButton.contains(event.target)
		if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
			this.play()
		} else if (this.autoplayButtonIsSetToPlay) {
			this.pause()
		}
	}

	play() {
		this.slider.setAttribute('aria-live', 'off')
		clearInterval(this.autoplay)
		this.autoplay = setInterval(
			this.autoRotateSlides.bind(this),
			this.autoplaySpeed
		)
	}

	pause() {
		this.slider.setAttribute('aria-live', 'polite')
		clearInterval(this.autoplay)
	}

	togglePlayButtonState(pauseAutoplay) {
		if (pauseAutoplay) {
			this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused')
			this.sliderAutoplayButton.setAttribute(
				'aria-label',
				window.accessibilityStrings.playSlideshow
			)
		} else {
			this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused')
			this.sliderAutoplayButton.setAttribute(
				'aria-label',
				window.accessibilityStrings.pauseSlideshow
			)
		}
	}

	autoRotateSlides() {
		const slideScrollPosition =
			this.currentPage === this.sliderItems.length
				? 0
				: this.slider.scrollLeft +
				  this.slider.querySelector('.slideshow__slide').clientWidth
		this.slider.scrollTo({
			left: slideScrollPosition,
		})
	}

	setSlideVisibility() {
		this.sliderItemsToShow.forEach((item, index) => {
			const linkElements = item.querySelectorAll('a')
			if (index === this.currentPage - 1) {
				if (linkElements.length)
					linkElements.forEach((button) => {
						button.removeAttribute('tabindex')
					})
				item.setAttribute('aria-hidden', 'false')
				item.removeAttribute('tabindex')
			} else {
				if (linkElements.length)
					linkElements.forEach((button) => {
						button.setAttribute('tabindex', '-1')
					})
				item.setAttribute('aria-hidden', 'true')
				item.setAttribute('tabindex', '-1')
			}
		})
	}

	linkToSlide(event) {
		event.preventDefault()
		const slideScrollPosition =
			this.slider.scrollLeft +
			this.sliderFirstItemNode.clientWidth *
				(this.sliderControlLinksArray.indexOf(event.currentTarget) +
					1 -
					this.currentPage)
		this.slider.scrollTo({
			left: slideScrollPosition,
		})
	}
}

customElements.define('slideshow-component', SlideshowComponent)

class VariantSelects extends HTMLElement {
	constructor() {
		super()
		this.addEventListener('change', this.onVariantChange)
	}

	onVariantChange() {
		this.updateOptions()
		this.updateMasterId()
		this.toggleAddButton(true, '', false)
		this.removeErrorMessage()

		if (!this.currentVariant) {
			this.toggleAddButton(true, '', true)
			this.setUnavailable()
		} else {
			this.updateMedia()
			this.updateURL()
			this.updateVariantInput()
			this.renderProductInfo()
			this.updateShareUrl()
		}
	}

	updateOptions() {
		this.options = Array.from(
			this.querySelectorAll('select'),
			(select) => select.value
		)
	}

	updateMasterId() {
		this.currentVariant = this.getVariantData().find((variant) => {
			return !variant.options
				.map((option, index) => {
					return this.options[index] === option
				})
				.includes(false)
		})
	}

	updateMedia() {
		if (!this.currentVariant) return
		if (!this.currentVariant.featured_media) return

		const mediaGalleries = document.querySelectorAll(
			`[id^="MediaGallery-${this.dataset.section}"]`
		)
		mediaGalleries.forEach((mediaGallery) =>
			mediaGallery.setActiveMedia(
				`${this.dataset.section}-${this.currentVariant.featured_media.id}`,
				true
			)
		)

		const modalContent = document.querySelector(
			`#ProductModal-${this.dataset.section} .product-media-modal__content`
		)
		if (!modalContent) return
		const newMediaModal = modalContent.querySelector(
			`[data-media-id="${this.currentVariant.featured_media.id}"]`
		)
		modalContent.prepend(newMediaModal)
	}

	/* The current variant's URL. data-url can already carry a query (the
	   wholesale preview's ?view=wholesale), so variant joins with & then. */
	variantUrl(extra = '') {
		const sep = this.dataset.url.includes('?') ? '&' : '?'
		return `${this.dataset.url}${sep}variant=${this.currentVariant.id}${extra}`
	}

	updateURL() {
		if (!this.currentVariant || this.dataset.updateUrl === 'false') return
		window.history.replaceState({}, '', this.variantUrl())
	}

	updateShareUrl() {
		const shareButton = document.getElementById(`Share-${this.dataset.section}`)
		if (!shareButton || !shareButton.updateUrl) return
		shareButton.updateUrl(`${window.shopUrl}${this.variantUrl()}`)
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
		)
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]')
			input.value = this.currentVariant.id
			input.dispatchEvent(new Event('change', { bubbles: true }))
		})
	}

	removeErrorMessage() {
		const section = this.closest('section')
		if (!section) return

		const productForm = section.querySelector('product-form')
		if (productForm) productForm.handleErrorMessage()
	}

	renderProductInfo() {
		const sourceSection = this.dataset.originalSection || this.dataset.section
		fetch(this.variantUrl(`&section_id=${sourceSection}`))
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, 'text/html')
				/* The blocks that follow the variant, copied from the fetched
				   section: the price, the product extras, and (wholesale) the
				   GTIN line under the description. */
				for (const prefix of ['price-', 'ProductExtras-', 'ProductGtin-']) {
					const destination = document.getElementById(`${prefix}${this.dataset.section}`)
					const source = html.getElementById(`${prefix}${sourceSection}`)
					if (source && destination) destination.innerHTML = source.innerHTML
				}

				const price = document.getElementById(`price-${this.dataset.section}`)

				if (price) price.classList.remove('visibility-hidden')
				this.toggleAddButton(
					!this.currentVariant.available,
					window.variantStrings.soldOut
				)
			})
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		const productForm = document.getElementById(
			`product-form-${this.dataset.section}`
		)
		if (!productForm) return
		const addButton = productForm.querySelector('[name="add"]')
		const addButtonText = productForm.querySelector('[name="add"] > span')
		if (!addButton) return

		if (disable) {
			addButton.setAttribute('disabled', 'disabled')
			if (text) addButtonText.textContent = text
		} else {
			addButton.removeAttribute('disabled')
			addButtonText.textContent = window.variantStrings.addToCart
		}
		if (!modifyClass) return
	}

	setUnavailable() {
		const button = document.getElementById(
			`product-form-${this.dataset.section}`
		)
		const addButton = button.querySelector('[name="add"]')
		const addButtonText = button.querySelector('[name="add"] > span')
		const price = document.getElementById(`price-${this.dataset.section}`)
		if (!addButton) return
		addButtonText.textContent = window.variantStrings.unavailable
		if (price) price.classList.add('visibility-hidden')
	}

	getVariantData() {
		this.variantData =
			this.variantData ||
			JSON.parse(this.querySelector('[type="application/json"]').textContent)
		return this.variantData
	}
}

customElements.define('variant-selects', VariantSelects)

class VariantRadios extends VariantSelects {
	constructor() {
		super()
		document.addEventListener('DOMContentLoaded', () => {
			this.updateOptions()
			this.setOptionAvailability()
		})
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll('fieldset'))
		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll('input')).find(
				(radio) => radio.checked
			).value
		})
		this.allOptions = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll('input')).map(
				(radio) => radio.value
			)
		})

		this.setOptionAvailability()
	}

	setOptionAvailability() {
		this.variants = this.getVariantData()

		this.allOptions.map((opt) => {
			opt.map((o) => {
				const possibleVariant = this.variants.find((va) => va.option1 == o)
				if (possibleVariant) {
					const input = this.querySelector(
						`[value="${possibleVariant.option1}"]`
					)
					if (input && !possibleVariant.available) {
						input?.classList.add('unavailable')
					}
				}
			})
		})
	}
}

customElements.define('variant-radios', VariantRadios)

class VariantDropdowns extends VariantRadios {
	connectedCallback() {
		super.connectedCallback?.()
		this._onResize = () => this.sizePills()
		window.addEventListener('resize', this._onResize, { passive: true })
		// ResizeObserver catches the case where the element starts hidden
		// (e.g. inside the quick-add modal) and becomes visible later —
		// without this, scrollWidth measures 0 on the initial pass.
		this._resizeObserver = new ResizeObserver(this._onResize)
		this._resizeObserver.observe(this)
		requestAnimationFrame(() => this.sizePills())
	}

	onVariantChange() {
		super.onVariantChange()
		this.updateStockIndicator()
	}

	updateStockIndicator() {
		const indicator = document.getElementById(
			`StockIndicator-${this.dataset.section}`
		)
		if (!indicator) return
		if (!this._lastOneIds) {
			const raw = indicator.dataset.lastOneIds || ''
			this._lastOneIds = new Set(
				raw.split(',').filter(Boolean).map(Number)
			)
		}
		const v = this.currentVariant
		const next = !(v && this._lastOneIds.has(v.id))
		if (indicator.hidden !== next) indicator.hidden = next
	}

	// VariantRadios.updateOptions queries 'fieldset' elements to find
	// variant groups, but our pill markup uses <div class="variant-pills">
	// (we dropped fieldset to fix the legend's special grid-layout
	// behaviour). Override to read from our groups instead — without this
	// the inherited variant-matching pipeline returns no options and every
	// non-default selection reads as Unavailable.
	updateOptions() {
		const groups = Array.from(this.querySelectorAll('.variant-pills'))
		this.options = groups
			.map((group) => {
				const checked = Array.from(
					group.querySelectorAll('input')
				).find((radio) => radio.checked)
				return checked?.value
			})
			.filter((v) => v !== undefined)
		this.allOptions = groups.map((group) =>
			Array.from(group.querySelectorAll('input')).map((radio) => radio.value)
		)
		this.setOptionAvailability()
	}

	disconnectedCallback() {
		super.disconnectedCallback?.()
		if (this._onResize) window.removeEventListener('resize', this._onResize)
		this._resizeObserver?.disconnect()
	}

	// All pills within a fieldset share the widest pill's natural content
	// width so the row reads as a uniform selector. The grid's auto-fill
	// + minmax(min-width, 1fr) does the actual layout — pills fill their
	// container instead of dictating its width.
	sizePills() {
		if (!this.offsetWidth) return
		this.querySelectorAll('.variant-pills').forEach((fs) => {
			const pills = Array.from(fs.querySelectorAll('.variant-pill'))
			if (!pills.length) return
			// width: max-content escapes the grid's 1fr stretching so
			// offsetWidth reflects each pill's natural content width.
			pills.forEach((p) => (p.style.width = 'max-content'))
			void pills[0].offsetWidth
			let maxWidth = 0
			pills.forEach((p) => {
				if (p.offsetWidth > maxWidth) maxWidth = p.offsetWidth
			})
			pills.forEach((p) => (p.style.width = ''))
			if (maxWidth > 0) {
				fs.style.setProperty('--pill-min-width', `${maxWidth}px`)
			}
		})
	}
}

customElements.define('variant-dropdowns', VariantDropdowns)

class QuickAtcVariantPicker extends VariantDropdowns {
	connectedCallback() {
		super.connectedCallback?.()
		// Sync the button to its computed initial state so the rendered
		// label matches the auto-selected variant's availability right
		// away (rather than waiting for the first change event).
		requestAnimationFrame(() => this.onVariantChange())
	}

	onVariantChange() {
		this.updateOptions()
		this.updateMasterId()
		// Inherited from VariantDropdowns: toggles the "Last one in
		// stock!" pill for the picked variant. data-section on this
		// element matches the stock indicator's id prefix in the modal.
		this.updateStockIndicator()

		if (!this._form) {
			this._form = this.closest('form')
			this._button = this._form?.querySelector('[data-atc-btn]')
			this._buttonLabel = this._button?.querySelector('.btnInner')
			this._idInput = this._form?.querySelector('input[name="id"]')
		}
		if (!this._form || !this._button || !this._buttonLabel || !this._idInput) return

		const strings = window.variantStrings || {}
		const variant = this.currentVariant

		let nextLabel
		let nextDisabled
		if (!variant) {
			nextLabel = strings.unavailable || 'Unavailable'
			nextDisabled = true
		} else if (variant.available) {
			nextLabel = strings.addToCart || 'Add to Cart'
			nextDisabled = false
		} else {
			nextLabel = strings.soldOut || 'Sold out'
			nextDisabled = true
		}

		if (this._buttonLabel.textContent !== nextLabel) {
			this._buttonLabel.textContent = nextLabel
		}
		if (this._button.disabled !== nextDisabled) {
			this._button.disabled = nextDisabled
		}

		if (!variant) return

		const nextId = String(variant.id)
		if (this._idInput.value !== nextId) this._idInput.value = nextId
		this.updatePriceDisplay()
	}

	updatePriceDisplay() {
		if (!this.currentVariant) return
		if (!this._priceCached) {
			const modal = this.closest('.quick-atc-modal')
			this._regPriceEl = modal?.querySelector('[data-reg-price]')
			this._comparePriceEl = modal?.querySelector('[data-compare-price]')
			// Pre-formatted price strings per variant (via Liquid
			// `money_with_currency`). Shopify Markets handles currency
			// conversion server-side, so this stays correct when a
			// shopper switches currency — unlike a JS arithmetic format.
			const priceScript = modal?.querySelector('[data-quick-prices]')
			if (priceScript) {
				try {
					const list = JSON.parse(priceScript.textContent || '[]')
					this._priceMap = new Map(list.map((p) => [p.id, p]))
				} catch {
					this._priceMap = new Map()
				}
			} else {
				this._priceMap = new Map()
			}
			this._priceCached = true
		}

		const entry = this._priceMap.get(this.currentVariant.id)
		if (!entry) return

		// innerHTML (vs textContent) so the <span class="price__currency">
		// wrap rendered by Liquid carries through — keeps the currency
		// code styling consistent with the main PDP price snippet. Safe:
		// the source is server-rendered Liquid output, not user input.
		if (this._regPriceEl && this._regPriceEl.innerHTML !== entry.price) {
			this._regPriceEl.innerHTML = entry.price
		}

		if (this._comparePriceEl) {
			const next = entry.compareAtPrice || ''
			if (this._comparePriceEl.innerHTML !== next) {
				this._comparePriceEl.innerHTML = next
			}
		}
	}
}

customElements.define('quick-atc-variant-picker', QuickAtcVariantPicker)

class ProductRecommendations extends HTMLElement {
	constructor() {
		super()
	}

	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return
			observer.unobserve(this)

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div')
					html.innerHTML = text
					const recommendations = html.querySelector('product-recommendations')

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML
					}

					if (
						!this.querySelector('slideshow-component') &&
						this.classList.contains('complementary-products')
					) {
						this.remove()
					}

					if (html.querySelector('.grid__item')) {
						this.classList.add('product-recommendations--loaded')
					}
				})
				.catch((e) => {
					console.error(e)
				})
		}

		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: '0px 0px 400px 0px',
		}).observe(this)
	}
}

customElements.define('product-recommendations', ProductRecommendations)

document.addEventListener('DOMContentLoaded', () => {
	const landingSwiper = new Swiper('#landingBanner', {
		direction: 'horizontal',
		slidesPerView: 1,
		spaceBetween: 0,
		speed: 600,
		loop: true,
		autoplay: {
			delay: 3000,
		},
		breakpoints: {
			1024: {
				slidesPerView: 'auto',
			},
		},
	})
})

document.addEventListener('DOMContentLoaded', () => {
	// Passive thumb strip: built-in thumbs integration handles the
	// active-thumb highlight via watchSlidesProgress, nothing else
	// animates the strip. slideToClickedSlide + autoScrollOffset each
	// fire their own animations on every interaction, which raced and
	// produced visible jitter when both were enabled.
	const productThumbnails = new Swiper('#productSwiperThumbnails', {
		direction: 'horizontal',
		slidesPerView: 'auto',
		spaceBetween: 16,
		watchSlidesProgress: true,
		resistance: false,
	})

	const productSwiper = new Swiper('#productSwiper', {
		direction: 'horizontal',
		slidesPerView: 1,
		spaceBetween: 0,
		// Wholesale only: stockist image sets mix square, landscape and portrait
		// shots, so the frame follows the image on screen (thumbnails move with
		// it) instead of holding the tallest one's height. Retail keeps its frame.
		autoHeight: document.body.classList.contains('co-ws'),
		loop: true,
		resistance: false,
		thumbs: {
			swiper: productThumbnails,
		},
		navigation: {
			nextEl: '#navigationNext',
			prevEl: '#navigationPrev',
		},
		breakpoints: {
			1024: {
				slidesPerView: 'auto',
			},
		},
	})
})

//formspark forms

const ajaxForms = document.querySelectorAll('[data-form-handler]')

Array.from(ajaxForms).map((form) => {
	form.addEventListener('submit', (evt) => {
		evt.preventDefault()

		const url = form.action
		const successCont = form.querySelector('[data-success]')
		const errorCont = form.querySelector('[data-error]')
		const submitBtn = form.querySelector('[data-submit-btn]')
		const formInner = form.querySelector('[data-form-inner]')

		let formData = new FormData(form)
		const formDataAsJSON = {}
		formData.forEach((value, key) => (formDataAsJSON[key] = value))
		submitBtn.textContent = 'Submitting'
		submitBtn.disabled = true

		const options = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
			},
			body: JSON.stringify(formDataAsJSON),
		}

		fetch(url, options)
			.then((res) => res.text())
			.then((res) => {
				if (successCont) successCont.removeAttribute('hidden')
				if (formInner) formInner.style.display = 'none'
			})
			.catch((err) => {
				errorCont.textContent = 'There has been an error, please refresh'
				console.error('this is the error', err)
			})
			.finally(() => {
				form.reset()
				submitBtn.textContent = 'Submit'
				submitBtn.disabled = false
			})
	})
})

const formatForm = (form) => {
	let formData = new FormData(form)
	const formatted = Object.fromEntries(formData)

	return formatted
}

// Splendid Voting Form

const splendidForm = document.querySelector('#splendidVoteForm')

if (splendidForm) {
	const submit = splendidForm.querySelector('button[type="submit"]')
	const errMsg = splendidForm.querySelector('#errMsg')
	const success = document.querySelector('#voteFormSuccess')
	const voted = document.querySelector('#votedMsg')

	const hasSubmitted = window.sessionStorage.getItem(
		'CoffeeOutdoorsSplendidVote'
	)

	if (hasSubmitted) {
		submit.remove()
		voted.classList.remove('hidden')
	}
	splendidForm.addEventListener('submit', async (evt) => {
		evt.preventDefault()
		const firstName = new FormData(splendidForm).get('firstName')
		if (firstName) {
			return
		}

		const images = new FormData(splendidForm).getAll('image')
		const url =
			'https://script.google.com/macros/s/AKfycbxgnVwZPD-oOhmIrv_tCZ3yUSDl_guaB89Ag5HLWLoTFATMX5FoK4LY3A9HA7yiN3uhjw/exec'

		submit.innerHTML = 'Submitting'
		submit.disabled = true

		const body = new FormData()
		images.map((x, i) => body.append(`image${i + 1}`, x))

		const json = await fetch('https://api.ipify.org?format=json')
			.then((res) => res.json())
			.catch((err) => console.error('There has been an error: ', err))

		if (json) {
			body.append('ip_address', json.ip)
		}

		await fetch(url, {
			method: 'POST',
			body,
		})
			.then((res) => {
				splendidForm.classList.add('hidden')
				success.classList.remove('hidden')
			})
			.finally(() => {
				window.sessionStorage.setItem('CoffeeOutdoorsSplendidVote', true)
			})
	})

	splendidForm.addEventListener('change', () => {
		const images = new FormData(splendidForm).getAll('image')
		if (images.length == 0) {
			submit.disabled = true
		} else if (images.length > 3) {
			submit.disabled = true
			errMsg && errMsg.classList.remove('hidden')
		} else {
			submit.disabled = false
			errMsg && errMsg.classList.add('hidden')
		}
	})
}

document.addEventListener('DOMContentLoaded', () => {
	var lightboxThumbnailSwiper = new Swiper('#lightboxThumbnailSwiper', {
		direction: 'horizontal',
		slidesPerView: 4,
		spaceBetween: 8,

		loop: true,
		spaceBetween: 8,
		watchSlidesProgress: true,
	})

	var lightboxSwiper = new Swiper('#lightboxSwiper', {
		slidesPerView: 1,
		centeredSlides: true,
		loop: true,
		thumbs: {
			swiper: lightboxThumbnailSwiper,
		},
		pagination: {
			el: '#lightboxPagination',
			type: 'fraction',
		},
	})

	const lightboxOpen = document.querySelectorAll('[data-lightbox-open')

	const lightbox = document.querySelector('#lightbox')
	const lightboxClose = document.querySelector('#lightboxClose')

	lightboxOpen.forEach((trigger) => {
		trigger.addEventListener('click', () => {
			const idx = trigger.dataset.lightboxOpen
			lightboxSwiper.slideTo(idx)
			/* Same lock as the in-store tip (see there); the close event
			   releases it on every exit, Escape included. */
			document.body.classList.add('js-dialog-open')
			lightbox.showModal()
		})
	})
	if (lightbox) {
		lightbox.addEventListener('close', () => {
			document.body.classList.remove('js-dialog-open')
		})
	}

	if (lightboxClose) {
		lightboxClose.addEventListener('click', (e) => {
			e.preventDefault()
			lightbox.close()
		})
	}
})

const weightWidgetInput = document.querySelector('#weightWidget')

if (weightWidgetInput) {
	weightWidgetInput.addEventListener('change', () => {
		const productGrid = document.querySelector('#product-grid')
		productGrid.classList.toggle('weight-widget-active')
		// const weightWidgets = document.querySelectorAll('[data-product-weight]')
		// weightWidgets.forEach((widget) => {
		// 	widget.classList.toggle('active')
		// })
	})
}

const inStoreTipTrigger = document.querySelector('#inStoreTipTrigger')
const inStoreTipModal = document.querySelector('#inStoreModal')
const inStoreTipClose = document.querySelector('#inStoreModalClose')

if (inStoreTipTrigger) {
	inStoreTipTrigger.addEventListener('click', () => {
		/* showModal() makes the page inert but does not stop it scrolling
		   under the wheel (desktop) or a finger (iOS); the shared overlay lock
		   does (body-class observer below). Released on the dialog's close
		   event, which every exit fires — Escape's cancel path included. */
		document.body.classList.add('js-dialog-open')
		inStoreTipModal.showModal()
		// showModal auto-focuses the first focusable child (the close X),
		// which on mobile WebKit can trigger :focus-visible and draw a
		// ring around the X. Move focus to the dialog itself; keyboard
		// users can still Tab to the close button.
		inStoreTipModal.focus()
	})

	// Backdrop click closes the modal. Registered once at module scope
	// (not inside the trigger handler) so repeated opens don't stack
	// additional listeners on every click.
	inStoreTipModal.addEventListener('click', (event) => {
		const content = inStoreTipModal.querySelector(
			'.in-store-tip__modal-content'
		)
		const rect = content.getBoundingClientRect()
		const isInDialog =
			rect.top <= event.clientY &&
			event.clientY <= rect.top + rect.height &&
			rect.left <= event.clientX &&
			event.clientX <= rect.left + rect.width
		if (!isInDialog) inStoreTipModal.close()
	})

	inStoreTipClose.addEventListener('click', () => {
		inStoreTipModal.close()
	})

	inStoreTipModal.addEventListener('close', () => {
		document.body.classList.remove('js-dialog-open')
	})
}

/* Open Cart */
function cartOpen() {
	const body = document.querySelector('body')
	body.classList.add('js-my-cart-open')
}

liquidAjaxCart.subscribeToCartAjaxRequests((state, subscribeToResult) => {
	if (state.requestType == 'add') {
		const form = state.info.initiator
		let btnInner = ''

		/* The word swap is for buttons that carry a label; an icon-only
		   submit (the cart pairs pop-up's + glyph) keeps its glyph. */
		const btn = form.querySelector('button[type="submit"]')
		const swapLabel = btn && btn.textContent.trim() !== ''
		if (swapLabel) {
			btnInner = btn.innerHTML
			btn.innerHTML = 'Adding'
		}

		subscribeToResult((state) => {
			if (state.responseData.ok) {
				// If the add came from inside the quick-add variant
				// picker, dismiss that drawer before opening the cart
				// so the customer lands on the checkout-ready view.
				if (form.closest('.quick-atc-modal')) {
					closeQuickATC()
				}
				// On the main cart page the cart is already in full view and
				// re-renders in place — popping the drawer over it (gift
				// wrapping, quick ATC from the grid below) is redundant.
				if (!document.querySelector('.cart-page')) {
					cartOpen()
				}
			}

			if (swapLabel) {
				setTimeout(() => {
					btn.innerHTML = btnInner
				}, 300)
			}
		})
	}
})

/* Stock-clamp desync repair. When a quantity change asks for more
   than is in stock, Shopify APPLIES the clamp (the cart really
   changes) yet answers 422 "Only N items were added to your cart
   due to availability." Liquid Ajax Cart treats any non-ok response
   as a failed request: it prints the message but skips the section
   re-render, so the drawer keeps showing the pre-change quantity
   and subtotal while the real cart holds the clamped amount — and
   checkout charges for what the cart really holds. On any failed
   change request that the server actually answered, re-sync from
   the server so the drawer shows what happened, then put the
   message back after the re-render wipes its container. */
let cartClampMessage = null

/* The line item's key for a change request's body, resolved the way
   Liquid Ajax Cart's messages module does it, so anything keyed off it
   lands in that line's data-ajax-cart-messages container and on that
   line's quantity input. Typed inputs send the key as `id`; the +/−
   request buttons send a 1-based `line`. */
const cartLineKey = (body) => {
	let id = null
	let line = null
	if (body instanceof FormData || body instanceof URLSearchParams) {
		id = body.get('id')
		line = body.get('line')
	} else if (body) {
		id = body.id
		line = body.line
	}
	if (id && String(id).indexOf(':') > -1) return String(id)
	const cartState = liquidAjaxCart.getCartState()
	if (!cartState.status.cartStateSet) return null
	const items = cartState.cart.items
	let item = null
	if (line) item = items[Number(line) - 1]
	else if (id) item = items.find((i) => i.id === Number(id))
	return item ? item.key : null
}

liquidAjaxCart.subscribeToCartAjaxRequests((state, subscribeToResult) => {
	if (state.requestType !== 'change') return
	subscribeToResult((result) => {
		if (result.info && result.info.cancel) return
		// No responseData means the fetch itself failed — the cart
		// can't have changed, so there is nothing to re-sync.
		if (!result.responseData || result.responseData.ok) return

		const body = result.requestBody
		const key = cartLineKey(body)
		const responseBody = result.responseData.body
		const text =
			responseBody && (responseBody.description || responseBody.message)
		let requestedQuantity = null
		if (body instanceof FormData || body instanceof URLSearchParams) {
			if (body.has('quantity')) requestedQuantity = Number(body.get('quantity'))
		} else if (body && 'quantity' in body) {
			requestedQuantity = Number(body.quantity)
		}
		if (key && text) cartClampMessage = { key, text, requestedQuantity }

		// Wipe Liquid Ajax Cart's own injection of Shopify's sentence
		// right away — it's three lines long in the drawer column and
		// would flash until the re-sync's re-render replaces it with
		// our copy.
		if (key) {
			document
				.querySelectorAll(`[data-ajax-cart-messages="${key}"]`)
				.forEach((el) => {
					el.innerHTML = ''
				})
		}

		liquidAjaxCart.cartRequestUpdate()
	})
})

/* The cart surface the shopper is looking at. /cart renders the drawer's
   markup as well (theme.liquid places the drawer section before
   #MainContent), hidden, so a first-match lookup by line key lands on that
   hidden copy and the pill and the busy spiral go where nobody sees them
   (pane, 2026-09-03: a + tap at the ceiling on /cart put "Only 4 in stock"
   in the closed drawer). The page, when there is one, is the surface; the
   drawer otherwise. */
const cartSurface = () =>
	document.querySelector('.cart-page') || document.querySelector('.cart-modal__inner') || document

/* One line's pill, in the container Liquid Ajax Cart's own messages use,
   with the same class so base.css styles both identically. */
const showCartLineMessage = (key, text) => {
	const container = cartSurface().querySelector(`[data-ajax-cart-messages="${key}"]`)
	if (!container) return
	const message = document.createElement('div')
	message.className = 'js-ajax-cart-message js-ajax-cart-message--error'
	message.textContent = text
	container.innerHTML = ''
	container.appendChild(message)
}

/* ajax-cart.liquid clamps a typed quantity or a + tap to the line's stock
   ceiling before any request and asks for the pill through this event. A
   clamp that still changes the quantity causes a re-render, which would wipe
   a pill shown now, so afterRender parks it for the sections-update
   subscriber below; a clamp to the quantity already in the cart sends
   nothing, and the pill shows at once. */
document.addEventListener('co:cart-line-message', (e) => {
	const { key, text, afterRender } = e.detail || {}
	if (!key || !text) return
	if (afterRender) cartClampMessage = { key, text, requestedQuantity: null }
	else showCartLineMessage(key, text)
})

/* Injected once no request is in progress — the queue is empty, so the
   re-render (and, after a 422, the re-sync's re-render) has landed. Not at
   sections-update: Liquid Ajax Cart's own messages module runs after that
   for a successful change and clears the line's container, which wiped a
   pill injected there (pane, 2026-09-03). Its modules subscribed before this
   one, so on the settled update they have already run. */
liquidAjaxCart.subscribeToCartStateUpdate((state) => {
	if (state.status.requestInProgress || !cartClampMessage) return
	const container = cartSurface().querySelector(
		`[data-ajax-cart-messages="${cartClampMessage.key}"]`
	)
	if (container) {
		// When this was a stock clamp (the re-synced line holds fewer
		// than asked for), swap Shopify's sentence for our one-liner —
		// the server wording runs three lines in the drawer column.
		// Anything else keeps the server's text.
		let text = cartClampMessage.text
		const requested = cartClampMessage.requestedQuantity
		// The clamped quantity comes from the re-rendered DOM, not
		// getCartState(): this callback can run before Liquid Ajax
		// Cart commits the update's state, and the stale state still
		// holds the PRE-change quantity (shipped that way once — a
		// clamp from 1 to 3 read "Only 1 in stock"). The freshly
		// rendered quantity input is the number the drawer displays,
		// so the message can never disagree with it.
		const renderedInput = cartSurface().querySelector(
			`[data-ajax-cart-quantity-input="${cartClampMessage.key}"]`
		)
		const clamped = renderedInput ? Number(renderedInput.value) : NaN
		if (requested && clamped > 0 && clamped < requested) {
			text = `Only ${clamped} in stock`
		}
		showCartLineMessage(cartClampMessage.key, text)
	}
	cartClampMessage = null
})

/* Busy state for a quantity change. Liquid Ajax Cart disables every cart
   field while a request is in flight and swaps the markup when the answer
   lands — 1.5s for a plain change, about 4s on a phone when Shopify answers
   422 and the re-sync above follows — and the drawer showed nothing for that
   window, so a tap on a field during it was silent (device logs
   2026-09-03). The quantity being changed now shows the brand spiral in
   place of its number (base.css, [data-busy]) from the request's start
   until no request is in progress: the chained re-sync keeps the queue
   busy, so the spiral holds through it, and the re-render replaces the row
   with the settled number. Requests with no line (the note, gift wrapping,
   the re-sync itself) keep their own words, or need none. */
liquidAjaxCart.subscribeToCartAjaxRequests((state) => {
	if (state.requestType !== 'change') return
	const key = cartLineKey(state.requestBody)
	const input = key && cartSurface().querySelector(`[data-ajax-cart-quantity-input="${key}"]`)
	const control = input && input.closest('.cart-modal-item__product-quantity')
	if (control) control.setAttribute('data-busy', '')
})
liquidAjaxCart.subscribeToCartStateUpdate((state) => {
	if (state.status.requestInProgress) return
	document
		.querySelectorAll('.cart-modal-item__product-quantity[data-busy]')
		.forEach((el) => el.removeAttribute('data-busy'))
})

/* Focus across a re-render. A click on a +/− link focuses it (desktop), the
   re-render removes the focused element, and Chrome then scrolled the page
   to its end (Tom, desktop /cart, 2026-09-03: focusin .product-quantity__btn,
   re-render, scrollY 1072 -> 2384). Typed changes never showed it: the field
   is blurred before its request. So nothing keeps focus while the DOM is
   swapped — at request start a control inside a section that will re-render
   is remembered (its line, its place in the quantity control) and blurred,
   and once the cart has settled the same control in the new markup gets
   focus back without scrolling. Keyboard users keep their place. */
let cartFocusToRestore = null
liquidAjaxCart.subscribeToCartAjaxRequests(() => {
	const a = document.activeElement
	if (!(a instanceof Element) || !a.closest('[data-ajax-cart-section]')) return
	/* A field that has just committed is finished with; `change` fires before
	   `blur`, so it is still the active element here, and giving the new one
	   focus after the re-render reopened it — the quantity script blanks a
	   focused field, so the shopper saw an empty box with a caret where the
	   settled number should be (Tom, desktop, 2026-09-03). Only the +/−
	   controls get their focus back. */
	if (a.matches('input, textarea')) { a.blur(); return }
	const control = a.closest('.cart-modal-item__product-quantity')
	const input = control && control.querySelector('[data-ajax-cart-quantity-input]')
	const key = input && input.getAttribute('data-ajax-cart-quantity-input')
	const index = control ? Array.prototype.indexOf.call(control.children, a) : -1
	cartFocusToRestore = key && index > -1 ? { key, index } : null
	a.blur()
})
liquidAjaxCart.subscribeToCartStateUpdate((state) => {
	if (state.status.requestInProgress || !cartFocusToRestore) return
	const { key, index } = cartFocusToRestore
	cartFocusToRestore = null
	if (document.activeElement !== document.body) return
	const input = cartSurface().querySelector(`[data-ajax-cart-quantity-input="${key}"]`)
	const control = input && input.closest('.cart-modal-item__product-quantity')
	const target = control && control.children[index]
	if (target && typeof target.focus === 'function') target.focus({ preventScroll: true })
})

const closeQuickATC = function () {
	document.querySelectorAll('.quick-atc-modal').forEach((m) => {
		m.classList.remove('active')
	})
	document.querySelectorAll('.quick-atc-modal__backdrop').forEach((b) => {
		b.classList.add('hidden')
	})
	/* Releases the shared page scroll lock (the body-class observer below). */
	document.body.classList.remove('js-quick-atc-open')
}

/* ---- Quick add: the modal is fetched, not shipped ----------------
   The modal carries the product's full variant JSON and a fieldset per
   variant — about 23KB. Rendered beside every card it was a third of a
   collection page's HTML for a dialog most visitors never open, and two
   cards of the same product produced duplicate `id`s, so a card's button
   could open a copy belonging to something else (the header renders
   first, so its copy won).

   Now one modal exists at a time, injected into #QuickAtcHost at the end
   of <body>. That also retires the old "move it to <body> on first open"
   dance: an ancestor inside product-recommendations created a containing
   block that trapped `position: fixed`, and the host has no such parent.

   Nothing needs re-initialising after injection: quick-atc-variant-picker
   is a custom element and upgrades itself, Liquid Ajax Cart listens for
   submit on `document`, and the backdrop's onclick calls a global. */
/* One loader per fetched `?view=` template (quick add, cart pairs). The
   cache holds the request promises themselves, so a second press while a
   fetch is in flight shares it, a failed fetch is forgotten so the next
   press retries, and cache.clear() forgets in-flight requests too — a
   response that lands after a clear cannot repopulate the cache. */
function viewLoader(view, label) {
	const cache = new Map()
	return {
		cache,
		load(trigger) {
			const id = trigger.getAttribute('data-product-id')
			if (cache.has(id)) return cache.get(id)
			const url = trigger.getAttribute('data-product-url')
			if (!url) return Promise.reject(new Error(`${label}: no product url`))
			const request = fetch(`${url}?view=${view}`, { credentials: 'same-origin' })
				.then((response) => {
					if (!response.ok) throw new Error(`${label}: HTTP ${response.status}`)
					return response.text()
				})
				.catch((error) => {
					if (cache.get(id) === request) cache.delete(id)
					throw error
				})
			cache.set(id, request)
			return request
		},
	}
}
const quickAtc = viewLoader('quick-atc', 'quick-add')
const cartPairs = viewLoader('cart-pairs', 'cart pairs')
const quickAtcHtml = (trigger) => quickAtc.load(trigger)

async function toggleQuickATC(trigger) {
	const host = document.getElementById('QuickAtcHost')
	if (!host) return

	/* A trigger inside an open native <dialog> (the cart pairs pop-up):
	   close it first, with a reason its close handler can read. This
	   drawer is not in the top layer, so it would be inert under one. */
	const hostDialog = trigger.closest('dialog[open]')
	if (hostDialog) hostDialog.close('quick-add')

	const productId = trigger.getAttribute('data-product-id')
	const open = host.querySelector('.quick-atc-modal.active')
	// Pressing the same card's button again closes, as it always has.
	if (open && open.getAttribute('data-product-id') === productId) {
		closeQuickATC()
		return
	}

	trigger.classList.add('is-loading')
	try {
		const html = await quickAtcHtml(trigger)
		host.innerHTML = html
		const modal = host.querySelector('.quick-atc-modal')
		if (!modal) throw new Error('quick-add: no modal in response')
		const backdrop = host.querySelector('.quick-atc-modal__backdrop')
		// Reflow so the browser commits the offscreen translateX(100%)
		// before .active animates it back to 0 — otherwise the slide is
		// skipped on the first open in Chrome/Safari.
		void modal.offsetWidth
		modal.classList.add('active')
		if (backdrop) backdrop.classList.remove('hidden')
		/* The page behind the scrim stops scrolling: the shared overlay lock
		   (body-class observer below), the same one the cart drawer raises. */
		document.body.classList.add('js-quick-atc-open')
	} catch (error) {
		// Send them to the product page rather than dead-ending the tap —
		// the intent was to buy this product, and the PDP can still do that.
		console.error(error)
		const url = trigger.getAttribute('data-product-url')
		if (url) window.location.href = url
	} finally {
		trigger.classList.remove('is-loading')
	}
}

document.addEventListener('click', (event) => {
	const trigger = event.target.closest('[data-quick-atc-modal-trigger]')
	if (trigger) {
		event.preventDefault()
		toggleQuickATC(trigger)
		return
	}

	if (event.target.closest('[data-modal-close]')) {
		closeQuickATC()
	}
})

/* Warm the cache before the click lands. pointerdown buys the press-to-
   release gap on every input type; hovering the button itself (not the
   card) is a deliberate enough signal to prefetch on, and fans out to one
   request rather than one per card in the grid. Failures are ignored —
   this is speculative, and the click path reports for real. */
const viewPrefetch = (event) => {
	const trigger = event.target.closest?.(
		'[data-quick-atc-modal-trigger], [data-cart-pairs-trigger]'
	)
	if (!trigger) return
	const loader = trigger.hasAttribute('data-cart-pairs-trigger') ? cartPairs : quickAtc
	loader.load(trigger).catch(() => {})
}
document.addEventListener('pointerdown', viewPrefetch, { passive: true })
document.addEventListener('mouseover', viewPrefetch, { passive: true })

/* ---- Cart pairs: the "Goes well with" sticker + pop-up -------------
   A cart row whose product carries custom.cart_pairs renders the trail
   marker + message chip on its thumbnail (snippets/cart-pairs-sticker).
   Pressing it fetches templates/product.cart-pairs.liquid for that
   product (see the template for why it is fetched, not shipped) into
   #CartPairsHost and opens it as a native <dialog> in the in-store tip's
   style. The rows show what the cart holds, so the loader's cache is
   dropped on every cart request (below). */
async function openCartPairs(trigger) {
	const host = document.getElementById('CartPairsHost')
	if (!host) return
	const productId = trigger.getAttribute('data-product-id')
	try {
		const html = await cartPairs.load(trigger)
		host.innerHTML = html
		const dialog = host.querySelector('[data-cart-pairs-modal]')
		if (!dialog) throw new Error('cart pairs: no dialog in response')
		/* The X, or a press outside the card: the dialog element is the
		   full-viewport scrim, so "outside" is simply "not in the content". */
		dialog.addEventListener('click', (event) => {
			if (
				event.target.closest('[data-cart-pairs-close]') ||
				!event.target.closest('.cart-pairs__modal-content')
			) {
				dialog.close()
			}
		})
		dialog.addEventListener('close', () => {
			/* Released on every exit, Escape's cancel path included. */
			document.body.classList.remove('js-dialog-open')
			/* Handed over to the quick-add picker (toggleQuickATC closes us
			   with this reason): focus is its business. Otherwise back to
			   the sticker, or its successor on the visible cart surface
			   after a re-render (it is gone once every pair is in). */
			if (dialog.returnValue !== 'quick-add') {
				const again = trigger.isConnected
					? trigger
					: cartSurface().querySelector(
							`[data-cart-pairs-trigger][data-product-id="${productId}"]`
					  )
				if (again) again.focus({ preventScroll: true })
			}
			/* Drop the dialog, its listeners and the captured sticker: a
			   detached sticker would keep the old drawer subtree alive. */
			host.replaceChildren()
		})
		/* Same lock as the in-store tip (body-class observer below);
		   showModal() also makes the drawer behind inert. */
		document.body.classList.add('js-dialog-open')
		dialog.showModal()
		/* showModal auto-focuses the close X; on mobile WebKit that can
		   draw a focus ring on it. Park focus on the dialog itself —
		   keyboard users still Tab to the X and the rows. */
		dialog.focus()
	} catch (error) {
		/* The intent was to see these products; the PDP can still show
		   what goes with it. Same fallback as quick add. */
		console.error(error)
		const url = trigger.getAttribute('data-product-url')
		if (url) window.location.href = url
	}
}

document.addEventListener('click', (event) => {
	const trigger = event.target.closest('[data-cart-pairs-trigger]')
	if (trigger) openCartPairs(trigger)
})

/* Every cart request: the pop-up's rows show what the cart holds, so the
   cached markup is stale. An add from one of its rows: busy spiral while
   in flight, then the tick + "In your cart" with the + disabled. */
liquidAjaxCart.subscribeToCartAjaxRequests((state, subscribeToResult) => {
	cartPairs.cache.clear()
	if (state.requestType !== 'add') return
	const form = state.info.initiator
	const row = form && form.closest ? form.closest('[data-cart-pairs-row]') : null
	if (!row) return
	row.classList.add('is-adding')
	subscribeToResult((result) => {
		row.classList.remove('is-adding')
		if (!result.responseData.ok) return
		row.classList.add('is-in-cart')
		const add = row.querySelector('.cart-pairs__add')
		if (add) add.disabled = true
	})
})

//Collection and Search Filtering
/* The mobile filter drawer toggle ([data-mobile-filter-toggle] /
   [data-mobile-filters]) is gone: it was the Boost-era drawer, and no
   template has rendered either attribute since the S&D migration. */

function changeParams(fromInput, toInput) {
	sessionStorage.setItem('fromValue', fromInput.value)
	sessionStorage.setItem('toValue', toInput.value)

	let searchParams = 'filter.v.price.gte'
	history.pushState(
		{
			searchParams,
		},
		'',
		`${window.location.pathname}${
			searchParams &&
			'?'.concat(
				searchParams +
					'=' +
					fromInput.value +
					'&filter.v.price.lte=' +
					toInput.value
			)
		}`
	)
	location.replace(window.location.href)
}

const priceInputs = document.querySelectorAll('[data-price-filter]')

priceInputs?.forEach((container) => {
	const fromInput = container.querySelector('[data-from-filter]')
	const toInput = container.querySelector('[data-to-filter')

	if (fromInput && toInput) {
		let timer = null
		let fromValue = sessionStorage.getItem('fromValue')
		let toValue = sessionStorage.getItem('toValue')

		fromInput.value = fromValue
		toInput.value = toValue

		fromInput.addEventListener('input', () => {
			if (timer) {
				clearTimeout(timer)
				timer = null
			}

			timer = setTimeout(() => {
				changeParams(fromInput, toInput)
				clearTimeout(timer)
				timer = null
			}, 1000)
		})

		toInput.addEventListener('input', () => {
			if (timer) {
				clearTimeout(timer)
				timer = null
			}

			timer = setTimeout(() => {
				changeParams(fromInput, toInput)
				clearTimeout(timer)
				timer = null
			}, 1000)
		})
	}
})

/* Overlay scroll lock — the mobile menu, the desktop mega menu and its
   search (desktop-nav.js), the cart drawer, the quick-add modal, Dawn
   ModalDialog overlays, the native <dialog>s (in-store tip, lightbox), the
   PDP media zoom (product-image-zoom.js), and the filter drawer. html
   overflow lock + scroll pin + touch guard, plus
   overscroll-behavior:contain on the overlays' own scrollers (CSS). The
   trigger classes are toggled from several places (global.js,
   liquidAjaxCart's data-ajax-cart-toggle-class-button, Dawn's ModalDialog),
   so a body class observer catches them all instead of patching every site.

   The mobile menu ran a parallel implementation of all of this until it
   became a body-level layer — html.co-scroll-locked, body.no-scroll, its own
   pin and its own touchmove guard, two copies of the same iOS workarounds
   under two near-identical class names. It is on js-menu-open now. (The
   open-glide that once kept it out — a programmatic scroll fighting the pin —
   is gone entirely; the menu no longer scrolls the page while locked.
   co:overlay-repin below remains live for filter-drawer.js.)

   Overlays whose insides may scroll while a lock is held carry
   data-co-scroll-allowed on their root (in the Liquid markup, or set
   from JS for script-built overlays like the zoom) — the one
   allowlist shared with the menu's touch guard, so a new overlay opts
   in with one attribute instead of edits to two guards. */
;(() => {
	const html = document.documentElement
	const body = document.body
	const WATCH = [
		'js-my-cart-open',
		'overflow-hidden',
		'js-filter-drawer-open',
		'js-menu-open',
		/* Desktop mega menu and its inline search — one writer, syncOverlay()
		   in desktop-nav.js, derived from both states. */
		'js-dnav-open',
		/* Quick add — toggleQuickATC / closeQuickATC above. */
		'js-quick-atc-open',
		/* The native <dialog>s — in-store tip, lightbox, cart pairs (above). */
		'js-dialog-open',
		/* The /cart page while one of its fields has focus (the cart module
		   below): the touch guard and the pin, but NOT the overflow lock —
		   the page stays visible behind the typing scrim and switching the
		   root to overflow:hidden would zero its scroll under the shopper. */
		'js-cart-typing',
	]
	const TOUCH_GUARD_ONLY = ['js-cart-typing']
	let pinnedY = null /* non-null = locked */

	/* The guard has to REFUSE the gesture, not correct it afterwards.

	   html { overflow: hidden } stops holding on iOS once the software keyboard
	   is up, and snapDrift cannot help: you cannot programmatically stop an
	   in-flight iOS touch scroll, so the scrollTo is simply overridden by the
	   compositor until the finger lifts. Device-measured with the mobile menu
	   open and the keyboard up: scrollY drifted 549 -> 438 across one drag, and
	   because the menu's bar is sticky and its panel is fixed, the two came
	   apart by exactly that 111px. The same drag is what pans the visual
	   viewport (offsetTop reached 379), which is what made the header look like
	   it was sliding up — with the keyboard up and no dragging, offsetTop reads
	   0.

	   So allowing a drag merely because it STARTED inside an overlay's scroller
	   is not enough. It is allowed only if that scroller can actually consume
	   it: a list already at its top cannot absorb a downward drag, and iOS
	   hands the leftover to the document. overscroll-behavior: contain is
	   supposed to cover this and does not, once the keyboard is up. */
	let dragStartY = 0
	let dragAllowedRoot = null

	/* The nearest box between the touch target and the overlay root that can
	   really scroll. The allowlisted root is often not the scroller itself. */
	const scrollableUnder = (target, root) => {
		let el = target instanceof Element ? target : null
		while (el) {
			if (el.scrollHeight > el.clientHeight + 1) {
				const oy = getComputedStyle(el).overflowY
				if (oy === 'auto' || oy === 'scroll') return el
			}
			if (el === root) break
			el = el.parentElement
		}
		return null
	}

	const onTouchStart = (e) => {
		if (e.touches.length !== 1) return
		dragStartY = e.touches[0].clientY
		dragAllowedRoot =
			e.target instanceof Element
				? e.target.closest('[data-co-scroll-allowed]')
				: null
	}

	const blockStrayTouchDrags = (e) => {
		if (e.touches.length !== 1) return /* leave pinch-zoom alone */
		if (!dragAllowedRoot) {
			e.preventDefault()
			return
		}
		const el = scrollableUnder(e.target, dragAllowedRoot)
		if (!el) {
			e.preventDefault() /* nothing here scrolls — the page would */
			return
		}
		const dy = e.touches[0].clientY - dragStartY
		const atTop = el.scrollTop <= 0
		const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1
		/* Finger down = content moves down = scrolling toward the top. */
		if ((dy > 0 && atTop) || (dy < 0 && atBottom)) e.preventDefault()
	}
	/* The lock stops user scrolling, so any scroll while pinned is
	   browser-initiated drift (e.g. keyboard scroll-into-view) — snap it
	   back, unconditionally: every overlay keeps its fields where no
	   keyboard reaches them (the menu's top band, the cart's note band), so
	   a document scroll is never the right response. An overlay that is
	   opaque and full-width adopts the drift itself instead, through
	   co:overlay-repin below (the menu; the cart on phones), because the
	   probe of 2026-09-02 showed every snap fight leaves Chrome iOS's
	   synthesised clicks offset by the disputed amount — the drawers with
	   the page visible beside them keep snapping. Letting the reveal-scroll through was
	   tried and showed the page behind the drawer. behavior:'instant' is
	   load-bearing: html has scroll-behavior:smooth, a plain scrollTo
	   would animate. */
	const snapDrift = () => {
		if (pinnedY === null) return
		if (window.scrollY !== pinnedY) {
			/* Through coScrollSafely, so __coScrollLock is raised around the
			   correction: this IS a programmatic scroll, and consumers that
			   watch scroll direction (the hide-on-scroll chain) must not read
			   it as the shopper moving. It was the one page-mover left that
			   scrolled without announcing itself. instant: the scroll settles
			   in the same task, so the short release window is right. */
			window.coScrollSafely(() => {
				window.scrollTo({ top: pinnedY, left: 0, behavior: 'instant' })
			}, { instant: true })
		}
	}

	const engage = () => {
		/* Read scrollY BEFORE the overflow lock lands: switching the root
		   to overflow:hidden zeroes the viewport scroll in the same task,
		   and the pin + snapDrift is what puts the shopper back. */
		pinnedY = window.scrollY
		const guardOnly = WATCH.every(
			(c) => !body.classList.contains(c) || TOUCH_GUARD_ONLY.includes(c)
		)
		if (!guardOnly) html.classList.add('co-overlay-locked')
		document.addEventListener('touchstart', onTouchStart, { passive: true })
		document.addEventListener('touchmove', blockStrayTouchDrags, {
			passive: false,
		})
		window.addEventListener('scroll', snapDrift)
	}
	const release = () => {
		pinnedY = null
		html.classList.remove('co-overlay-locked')
		document.removeEventListener('touchstart', onTouchStart)
		document.removeEventListener('touchmove', blockStrayTouchDrags)
		dragAllowedRoot = null
		window.removeEventListener('scroll', snapDrift)
	}

	/* An overlay that intentionally moves the page while it holds the
	   lock (the filter drawer scrolls to top after swapping in a fresh
	   result grid) dispatches this AFTER its scrollTo so the pin adopts
	   the new position instead of snapping it back. Synchronous on
	   purpose: scrollTo sets scrollY in the same task, the scroll event
	   snapDrift sees fires later — by then the pin already matches. */
	document.addEventListener('co:overlay-repin', () => {
		if (pinnedY !== null) pinnedY = window.scrollY
	})

	new MutationObserver(() => {
		const want = WATCH.some((c) => body.classList.contains(c))
		if (want === (pinnedY !== null)) return
		want ? engage() : release()
	}).observe(body, { attributes: true, attributeFilter: ['class'] })
})()

/* Cart drawer note — all of its behavior lives here, OUTSIDE the
   liquidAjaxCart re-render zone (the drawer's <form data-ajax-cart-section>
   is replaced wholesale on every cart request), via document-level
   delegation. Three cooperating parts:

   1. NOTE BAND — the note textarea sits in the drawer's footer, at the
      bottom, which the iOS keyboard would cover. Nothing is measured to
      solve that: on a touch device, while the note has focus, the note
      section is pinned to the top of the drawer as a band (base.css,
      .co-note-band) — the same row and field, in a place no keyboard can
      reach — and the rest of the drawer goes behind the site's scrim. On
      blur it returns to the footer, expanded, text on show. A drag on the
      dimmed area arms a dismissal that fires when the finger lifts; a tap
      on it is done as well. While ANY field in the drawer has focus
      (data-typing) the list is not a scroll container, so the shared touch
      guard refuses every drag at its first touchmove and nothing can chain
      to the page. This replaced a footer lift by a measured keyboard
      height (a 42vh estimate, a painted skirt, innerHeight cached at focus)
      after the Zero-Measurement probe (PR #200) showed what such
      measurements cost.

   2. TOGGLE SEMANTICS — while typing, the toggle means "done": blur
      (keyboard away, footer glides back) and keep the note open with
      the text on show; only a tap with no keyboard up collapses it.
      "Was typing" is captured at pointerdown because iOS can move
      focus off the textarea before click fires.

   3. RE-RENDER RESTORE — the server markup defaults the note to
      collapsed, so after any cart request the fresh subtree would snap
      it shut; re-apply the expanded state (and any unsaved draft)
      inside the mutation callback, before the new subtree paints.
      Saving the note itself does NOT re-render: the textarea is
      deliberately not a liquidAjaxCart property input — nothing in the
      drawer displays the note, so it saves via a plain cart update. */
;(() => {
	let noteOpen = false
	let noteContainer = null /* which cart context (drawer or /cart page) the open note lives in */
	let noteDraft = null
	let wasTyping = false
	/* stable wrappers around the two re-rendered cart forms */
	const NOTE_CONTAINERS = '.cart-modal__inner-container, .cart-page'

	/* ---- 1. bands + typing state, on both cart surfaces ------------ */
	/* Touch devices only: a fine pointer never raises an on-screen keyboard,
	   and with a hardware keyboard there is nothing to keep clear of. */
	const TOUCH_DEVICE = navigator.maxTouchPoints > 0
	/* The drawer and the /cart page share the rows, the footer composition and
	   now the typing design (Tom, 2026-09-03): the field a shopper is typing in
	   becomes a band at the top, the rest goes behind the scrim, nothing
	   scrolls under the finger, a drag or a tap on the scrim is done. The page
	   adds one thing the drawer gets from being open — the shared lock,
	   engaged through js-cart-typing on <body> (the lock's own observer), so
	   its touch guard refuses page drags while a field has focus. Scrolls the
	   browser makes meanwhile are adopted, never fought, and the page is put
	   back where the shopper had it once the field blurs. */
	const SURFACES = '.cart-modal__inner, .cart-page'
	const surfaceOf = (el) => (el instanceof Element ? el.closest(SURFACES) : null)
	const isCartField = (el) =>
		el instanceof Element && el.matches('input, textarea') && !!surfaceOf(el)
	/* The rules these surfaces implement, for the overlay diagnostic
	   (assets/comnav-diag.js, ?codiag=cart and ?codiag=page), which gates its
	   assertions on them. Declared only where enforced: a fine pointer gets no
	   bands and no typing state, and a declaration the diag then asserts read
	   as TYPING-DRIFT on a desktop (Tom's log, 2026-09-03). The drawer's adopt
	   rule is stamped by its own module. */
	if (TOUCH_DEVICE) {
		const drawer = document.querySelector('.cart-modal__inner')
		if (drawer) drawer.dataset.rules = 'typing'
		const page = document.querySelector('.cart-page')
		if (page) page.dataset.rules = 'typing adopt'
	}

	const PAGE_TYPING = 'js-cart-typing'
	let pageTypingY = null
	/* Capture phase, so it runs before the lock's snapDrift on the same event. */
	window.addEventListener('scroll', () => {
		if (pageTypingY === null) return
		document.dispatchEvent(new Event('co:overlay-repin'))
	}, { capture: true, passive: true })

	document.addEventListener('focusin', (e) => {
		if (!TOUCH_DEVICE || !isCartField(e.target)) return
		const surface = surfaceOf(e.target)
		surface.setAttribute('data-typing', '')
		if (surface.matches('.cart-page') && pageTypingY === null) {
			pageTypingY = window.scrollY
			document.body.classList.add(PAGE_TYPING)
		}
		if (e.target.matches('.cart-modal-item__product-quantity-input')) {
			/* Rule one for a quantity field: the control itself becomes a band
			   at the top (base.css, .co-qty-band) — by STYLE, inside the focus,
			   exactly as the note does. Not by scrolling its row to the top of
			   the list: the device log of 2026-09-03 showed WebKit computing
			   its reveal from the field's position before a scroll made inside
			   the focus, and panning the visual viewport 233px to a place the
			   field had already left. */
			surface.classList.add('co-qty-band')
			return
		}
		if (!e.target.matches('.cart-modal__note-textarea')) return
		/* The section's own SETTLED height, read before it leaves the footer's
		   flow, so the footer can hold its place (base.css). The expand
		   transition clamps .cart-modal__note-content with max-height for
		   300ms, and a shopper can tap the field inside that window, so the
		   clamped part is added back from scrollHeight. An element
		   measurement, not a viewport one. */
		const section = e.target.closest('.cart-modal__note-section')
		const content = section?.querySelector('.cart-modal__note-content')
		if (section) {
			const clamped = content ? Math.max(0, content.scrollHeight - content.clientHeight) : 0
			surface.style.setProperty('--co-note-h', section.offsetHeight + clamped + 'px')
		}
		surface.classList.add('co-note-band')
	})
	document.addEventListener('focusout', (e) => {
		if (!isCartField(e.target)) return
		const surface = surfaceOf(e.target)
		surface.removeAttribute('data-typing')
		surface.classList.remove('co-note-band', 'co-qty-band')
		surface.style.removeProperty('--co-note-h')
		if (!surface.matches('.cart-page') || pageTypingY === null) return
		/* Focus going straight to another field on the page keeps the lock and
		   the remembered position; the page is put back once typing is over. */
		if (isCartField(e.relatedTarget) && surfaceOf(e.relatedTarget) === surface) return
		const y = pageTypingY
		pageTypingY = null
		if (window.scrollY !== y) {
			const restore = () => window.scrollTo({ top: y, left: 0, behavior: 'instant' })
			typeof window.coScrollSafely === 'function'
				? window.coScrollSafely(restore, { instant: true })
				: restore()
			document.dispatchEvent(new Event('co:overlay-repin'))
		}
		document.body.classList.remove(PAGE_TYPING)
	})

	/* Rule two, the menu's shape: a drag anywhere outside the focused field's
	   own control arms a dismissal that fires when the finger LIFTS — never
	   under a finger that is still down (device log 2026-09-02: dismissing on
	   touchmove handed the still-down finger to iOS's native scroller five
	   times out of five). A plain tap on the scrim — whose event target is
	   the surface itself, a pseudo-element having none — is done as well. The
	   shared guard has already refused the scroll: the drawer's list is
	   overflow hidden while data-typing is set, and the page holds the lock. */
	let dismissArmed = null
	document.addEventListener('touchmove', (e) => {
		if (e.touches.length !== 1 || dismissArmed) return
		const a = document.activeElement
		if (!isCartField(a)) return
		const own = a.closest('.cart-modal__note-section, .cart-modal-item__product-quantity')
		if (a === e.target || own?.contains(e.target)) return
		dismissArmed = a
	}, { passive: true })
	const releaseDismiss = (e) => {
		const a = document.activeElement
		const surface = surfaceOf(a)
		const tapOnScrim = e.type === 'touchend' && !!surface && e.target === surface &&
			(surface.classList.contains('co-note-band') || surface.classList.contains('co-qty-band'))
		if (!dismissArmed && !tapOnScrim) return
		dismissArmed = null
		if (isCartField(a)) setTimeout(() => { if (document.activeElement === a) a.blur() }, 0)
	}
	document.addEventListener('touchend', releaseDismiss, { passive: true })
	document.addEventListener('touchcancel', releaseDismiss, { passive: true })

	/* ---- 2. toggle + save + label -------------------------------- */
	const noteParts = (el) => {
		const section = el.closest('.cart-modal__note-section')
		return [section, section?.querySelector('.cart-modal__note-textarea')]
	}
	document.addEventListener('pointerdown', (e) => {
		const btn = e.target.closest?.(
			'.cart-modal__note-toggle, .cart-modal__note-indicator'
		)
		if (!btn) return
		const [, textarea] = noteParts(btn)
		wasTyping = document.activeElement === textarea
	})
	document.addEventListener('click', (e) => {
		const btn = e.target.closest?.(
			'.cart-modal__note-toggle, .cart-modal__note-indicator'
		)
		if (!btn) return
		const [section, textarea] = noteParts(btn)
		const doneTyping = wasTyping || document.activeElement === textarea
		wasTyping = false
		if (doneTyping) {
			textarea.blur()
			return /* stays open — noteOpen is already true */
		}
		noteOpen = section.classList.toggle('note-expanded')
		noteContainer = noteOpen ? section.closest(NOTE_CONTAINERS) : null
	})
	document.addEventListener('input', (e) => {
		if (!e.target.matches?.('.cart-modal__note-textarea')) return
		noteDraft = e.target.value
		const label = e.target
			.closest('.cart-modal__note-section')
			.querySelector('.note-toggle-text')
		label.textContent = e.target.value.trim() !== '' ? 'Edit Note' : 'Add Note'
	})
	document.addEventListener('change', (e) => {
		if (!e.target.matches?.('.cart-modal__note-textarea')) return
		fetch(window.routes?.cart_update_url || '/cart/update.js', {
			...(typeof fetchConfig === 'function' ? fetchConfig() : {}),
			body: JSON.stringify({ note: e.target.value }),
		}).catch((err) => console.error('Cart note save failed', err))
	})

	/* ---- 3. re-render restore ------------------------------------ */
	/* liquidAjaxCart replaces each <form data-ajax-cart-section> node
	   wholesale as a direct child of its stable wrapper (verified: node
	   identity changes across a re-render). One observer per cart
	   context — the drawer renders on every page, the /cart page adds
	   its own — restoring only the note the user actually opened. */
	document.querySelectorAll(NOTE_CONTAINERS).forEach((container) => {
		new MutationObserver(() => {
			if (!noteOpen || noteContainer !== container) return
			const section = container.querySelector('.cart-modal__note-section')
			if (!section || section.classList.contains('note-expanded')) return
			section.classList.add('note-expanded')
			const ta = section.querySelector('.cart-modal__note-textarea')
			if (ta && typeof noteDraft === 'string' && ta.value !== noteDraft) {
				/* a re-render landed mid-edit — the server still has the old
				   note; the draft is newer */
				ta.value = noteDraft
			}
		}).observe(container, { childList: true })
	})
})()

/* Cart drawer: the slide transform lasts only as long as the slide.

   .cart-modal__inner slides in with translateX(100%) -> translateX(0) and
   used to keep translateX(0) for as long as it was open. An identity
   transform is still a transform: WebKit draws the text caret in
   untransformed coordinates, so the note's and the quantity fields' carets
   rendered displaced (header audit, 2026-08-28), and any position: fixed
   descendant took the drawer as its containing block. Once the slide has
   finished, is-settled switches the transform to none (base.css); dropping
   the class when the drawer closes lets the base rule's translateX(100%)
   animate out from `none`, which interpolates as the identity.

   Settled on the transform's transitionend, with two backstops: reduced
   motion strips the transition so no event fires, and a tab hidden
   mid-slide can miss it. */
;(() => {
	const inner = document.querySelector('.cart-modal__inner')
	if (!inner) return
	const isOpen = () => document.body.classList.contains('js-my-cart-open')
	const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)')
	let settleTimer = null
	const settle = () => {
		clearTimeout(settleTimer)
		settleTimer = null
		if (isOpen()) inner.classList.add('is-settled')
	}
	inner.addEventListener('transitionend', (e) => {
		if (e.target === inner && e.propertyName === 'transform') settle()
	})

	/* ── Rule three, on phones: nothing to fight ──────────────────────
	   Under 768px the drawer is 100vw and opaque (base.css), so a
	   browser-initiated scroll of the page while it is open — WebKit
	   centring a focused field, the adjustment iOS makes on rotation — is
	   ADOPTED through the shared lock's co:overlay-repin handshake instead of
	   being snapped back, and the page is put back once at close, behind the
	   still-covering drawer. The menu does the same everywhere; the probe of
	   2026-09-02 showed that every snap fight left Chrome iOS's synthesised
	   clicks landing below the touch, which is what "taps freeze" was. On a
	   tablet the drawer is 35vw with the page visible beside it, so the snap
	   stays and rules one and two remove the scrolls that caused fights.
	   Capture phase so it runs before snapDrift's bubble-phase listener on
	   the same event. */
	const PHONE = window.matchMedia?.('(max-width: 768px)')
	let adopting = false
	let openScrollY = null
	window.addEventListener('scroll', () => {
		if (!adopting || !isOpen()) return
		document.dispatchEvent(new Event('co:overlay-repin'))
	}, { capture: true, passive: true })
	window.addEventListener('pagehide', () => { openScrollY = null; adopting = false })
	inner.dataset.rules = ((inner.dataset.rules || '') + ' adopt').trim()

	let wasOpen = isOpen()
	new MutationObserver(() => {
		const open = isOpen()
		if (open === wasOpen) return
		wasOpen = open
		if (!open) {
			clearTimeout(settleTimer)
			settleTimer = null
			inner.classList.remove('is-settled')
			adopting = false
			if (openScrollY !== null) {
				const y = openScrollY
				openScrollY = null
				if (window.scrollY !== y) {
					const restore = () => window.scrollTo({ top: y, left: 0, behavior: 'instant' })
					typeof window.coScrollSafely === 'function'
						? window.coScrollSafely(restore, { instant: true })
						: restore()
					document.dispatchEvent(new Event('co:overlay-repin'))
				}
			}
			return
		}
		adopting = !!(PHONE && PHONE.matches)
		openScrollY = adopting ? window.scrollY : null
		if (reduced?.matches) { settle(); return }
		settleTimer = setTimeout(settle, 450)
	}).observe(document.body, { attributes: true, attributeFilter: ['class'] })
})()
